module.exports = __webpack_public_path__ + "img/cry.6e25808e.svg";